import { render, staticRenderFns } from "./devicesDashboardForm.vue?vue&type=template&id=56c5bbc6&scoped=true"
import script from "./devicesDashboardForm.vue?vue&type=script&lang=js"
export * from "./devicesDashboardForm.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardForm.vue?vue&type=style&index=0&id=56c5bbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5bbc6",
  null
  
)

export default component.exports